import "./Tienda.css";

import vipImg from "../assets/tienda/vip.jpg";
import vipPlusImg from "../assets/tienda/vipplus.jpg";
import eliteImg from "../assets/tienda/elite.jpg";

const rangos = [
  {
    nombre: "VIP",
    precio: "S/ 15.00",
    duracion: "30 DÍAS",
    destacado: "MÁS POPULAR",
    clase: "vip",
    imagen: vipImg,
    beneficios: [
      "Kit VIP semanal",
      "Prioridad en cola",
      "Tag VIP en Discord",
      "Acceso a comandos especiales",
    ],
  },
  {
    nombre: "VIP+",
    precio: "S/ 25.00",
    duracion: "30 DÍAS",
    clase: "vipplus",
    imagen: vipPlusImg,
    beneficios: [
      "Todo lo del VIP",
      "Kit VIP+ semanal",
      "Mayor recompensa diaria",
      "Acceso a zona exclusiva",
    ],
  },
  {
    nombre: "ELITE",
    precio: "S/ 40.00",
    duracion: "30 DÍAS",
    clase: "elite",
    imagen: eliteImg,
    beneficios: [
      "Todo lo del VIP+",
      "Kit Elite premium",
      "Prioridad máxima",
      "Color exclusivo en el chat",
    ],
  },
];

const Tienda = () => {
  return (
    <main className="tienda-page">
      <section className="tienda-header">
        <span>🛒 TIENDA OFICIAL</span>
        <h1>
          Rangos <strong>VIP</strong>
        </h1>
        <p>Apoya al servidor y obtén beneficios exclusivos dentro del juego.</p>
      </section>

      <section className="rangos-section">
        <div className="rangos-grid">
          {rangos.map((rango) => (
            <article className={`rango-card ${rango.clase}`} key={rango.nombre}>
              {rango.destacado && (
                <span className="rango-destacado">⭐ {rango.destacado}</span>
              )}

              <div className="rango-imagen">
                <img src={rango.imagen} alt={rango.nombre} />
              </div>

              <div className="rango-body">
                <h2>{rango.nombre}</h2>
                <p className="rango-precio">{rango.precio}</p>
                <span className="rango-duracion">{rango.duracion}</span>

                <ul>
                  {rango.beneficios.map((beneficio, index) => (
                    <li key={index}>✔ {beneficio}</li>
                  ))}
                </ul>

                <button className="comprar-btn">🛒 COMPRAR AHORA</button>
              </div>
            </article>
          ))}
        </div>

        <div className="tienda-info">
          <div>
            <strong>🛡 Pago 100% Seguro</strong>
            <p>Transacciones protegidas</p>
          </div>

          <div>
            <strong>⚡ Entrega Automática</strong>
            <p>Rango al instante</p>
          </div>

          <div>
            <strong>🎧 Soporte 24/7</strong>
            <p>Estamos para ayudarte</p>
          </div>

          <div>
            <strong>🎁 Beneficios Exclusivos</strong>
            <p>Mejora tu experiencia</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Tienda;